import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import InputField from "components/fields/InputField";
import Modal from "components/modal";
import Switch from "components/switch";
import { createAnnouncement } from "store/announcementSlice";

function AddAnnouncement({ refreshList }) {
  const dispatch = useDispatch();
  const { createLoading } = useSelector((state) => state.announcements);

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    reset();
    setIsOpen(false);
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      message: "",
      backgroundColor: "#000000",
      textColor: "#FFFFFF",
      isActive: true,
    },
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      const response = await dispatch(createAnnouncement(data));
      if (
        response?.payload?.statuscode === 201 ||
        response?.payload?.statuscode === 200
      ) {
        refreshList?.();
        closeModal();
        reset();
      }
    } catch (error) {
      console.error("Create announcement failed:", error);
    }
  };

  return (
    <div>
      <Button onClick={openModal}>Add Announcement</Button>

      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-md">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Add Announcement
        </h2>

        <div className="mt-5 w-full flex-col items-center lg:pl-0">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="mx-auto grid w-full grid-cols-1 gap-4"
            noValidate
          >
            <InputField
              id="add-message"
              variant="auth"
              label="Message*"
              placeholder="Enter announcement message"
              type="text"
              error={errors.message}
              {...register("message", { required: "Message is required" })}
            />

            <div className="grid grid-cols-2 gap-4">
              <Controller
                name="backgroundColor"
                control={control}
                render={({ field }) => (
                  <div className="flex flex-col gap-1">
                    <label className="ml-1.5 text-sm font-medium text-navy-700 dark:text-white">
                      Background Color
                    </label>
                    <div className="flex items-center gap-3">
                      <input
                        type="color"
                        id="add-backgroundColor"
                        value={field.value || "#000000"}
                        onChange={(e) => field.onChange(e.target.value)}
                        className="bg-transparent h-10 w-14 cursor-pointer rounded border border-gray-300 p-0.5 dark:border-gray-600"
                      />
                      <span className="text-sm text-navy-700 dark:text-white">
                        {field.value || "#000000"}
                      </span>
                    </div>
                  </div>
                )}
              />
              <Controller
                name="textColor"
                control={control}
                render={({ field }) => (
                  <div className="flex flex-col gap-1">
                    <label className="ml-1.5 text-sm font-medium text-navy-700 dark:text-white">
                      Text Color
                    </label>
                    <div className="flex items-center gap-3">
                      <input
                        type="color"
                        id="add-textColor"
                        value={field.value || "#FFFFFF"}
                        onChange={(e) => field.onChange(e.target.value)}
                        className="bg-transparent h-10 w-14 cursor-pointer rounded border border-gray-300 p-0.5 dark:border-gray-600"
                      />
                      <span className="text-sm text-navy-700 dark:text-white">
                        {field.value || "#FFFFFF"}
                      </span>
                    </div>
                  </div>
                )}
              />
            </div>

            <Controller
              name="isActive"
              control={control}
              render={({ field }) => (
                <div className="flex flex-col gap-1">
                  <label className="ml-1.5 text-sm font-medium text-navy-700 dark:text-white">
                    Status
                  </label>
                  <div className="flex items-center gap-3">
                    <Switch
                      checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                    <span className="text-sm text-navy-700 dark:text-white">
                      {field.value ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              )}
            />

            <div className="my-4 flex items-center justify-end gap-2 pt-2">
              <Button type="button" variant="outline" onClick={closeModal}>
                Cancel
              </Button>
              <LoaderButton type="submit" isLoading={createLoading}>
                Add Announcement
              </LoaderButton>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default AddAnnouncement;
